var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.temDocumento())?_c('span',[_c('span',{staticClass:"text-primary ml-1"},[_c('i',{staticClass:"fa fa-file fa-lg icon-button",attrs:{"title":"Documentação de validação"},on:{"click":function($event){$event.stopPropagation();return _vm.toDetalhar()}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }